@let hint = ((hintKey$ | async) ?? '') | translate;

<ts-algorithm-selector
  class="algorithm-selector"
  [options]="options$ | async"
  [loaded]="loaded$ | async"
  [searchTerm]="initialSearchTerm$ | async"
  [value]="selectedAlgorithm$ | async"
  [hint]="hint"
  [noItemsMessage]="'table.algorithms.switch_algorithm_dialog.no_items' | translate"
  [ariaLabel]="hint"
  [dataCy]="'switch-algorithm-selector'"
  [error]="algorithmListError$ | async"
  (valueChange)="switchToAlgorithm($event?.id)"
  (lastItemReached)="onLastItemReached()"
  (searchTermChanged)="searchAlgorithm($event)"
></ts-algorithm-selector>

<mat-checkbox class="include-deprecated-toggle" (change)="includeDeprecatedChanged($event.checked)">
  {{ 'table.algorithms.filters.include_deprecated' | translate }}
</mat-checkbox>

<div *ngIf="deprecatedWarning$ | async" class="warning">
  <i class="ri-alert-line warning-icon" aria-hidden="true"></i>
  <p class="warning-text">
    {{ 'table.algorithms.switch_algorithm_dialog.using_deprecated' | translate }}
  </p>
</div>

<div *ngIf="compatibilityWarning$ | async as warningKey" class="warning">
  <i class="ri-alert-line warning-icon" aria-hidden="true"></i>
  <div class="warning-body">
    <p class="warning-text">{{ warningKey | translate }}</p>
    <div class="label-chips" *ngIf="(mismatchedLabels$ | async)?.length">
      <span class="label-chip" *ngFor="let label of mismatchedLabels$ | async" [title]="label.displayName">
        <span>{{ label.displayName }}</span>
        <span class="label-chip-uuid" *ngIf="label.displayName !== label.uuid">· {{ label.uuid }}</span>
      </span>
    </div>
  </div>
</div>

<div *ngIf="compatibilityError$ | async as compatibilityError" class="error">
  <i class="ri-error-warning-line error-icon" aria-hidden="true"></i>
  <p class="error-text">{{ compatibilityError | translate }}</p>
</div>
